import * as React from 'react';
import { cn } from '@/lib/cn';

interface Props {
  beforeSrc: string;
  afterSrc: string;
  alt?: string;
  className?: string;
}

export const BeforeAfter: React.FC<Props> = ({ beforeSrc, afterSrc, alt = '', className }) => {
  const [pos, setPos] = React.useState(50);
  const ref = React.useRef<HTMLDivElement>(null);

  const onMove = (clientX: number): void => {
    const el = ref.current;
    if (!el) return;
    const rect = el.getBoundingClientRect();
    const p = ((clientX - rect.left) / rect.width) * 100;
    setPos(Math.max(0, Math.min(100, p)));
  };

  return (
    <div
      ref={ref}
      className={cn(
        'relative select-none overflow-hidden rounded-lg border bg-muted aspect-[4/3]',
        className,
      )}
      onPointerMove={(e) => e.buttons === 1 && onMove(e.clientX)}
      onPointerDown={(e) => {
        (e.currentTarget as HTMLElement).setPointerCapture(e.pointerId);
        onMove(e.clientX);
      }}
      aria-label="comparar antes e depois"
    >
      <img src={afterSrc} alt={`depois — ${alt}`} className="absolute inset-0 h-full w-full object-cover" />
      <div
        className="absolute inset-y-0 left-0 overflow-hidden"
        style={{ width: `${pos}%` }}
      >
        <img src={beforeSrc} alt={`antes — ${alt}`} className="absolute inset-0 h-full w-full object-cover" />
      </div>
      <div
        className="absolute inset-y-0 w-0.5 bg-primary shadow-lg"
        style={{ left: `calc(${pos}% - 1px)` }}
      >
        <div className="absolute top-1/2 -translate-y-1/2 -translate-x-1/2 rounded-full bg-primary text-primary-foreground size-8 grid place-items-center text-xs font-bold shadow-lg">
          ↔
        </div>
      </div>
      <span className="absolute left-3 top-3 rounded bg-background/80 px-2 py-1 text-xs font-medium uppercase">
        Antes
      </span>
      <span className="absolute right-3 top-3 rounded bg-primary px-2 py-1 text-xs font-medium uppercase text-primary-foreground">
        Depois
      </span>
    </div>
  );
};
